import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AlioModule } from '../alio/alio.module';
import { SharedModule } from '../shared/shared.module';
import { AlioDrawerComponent } from './alio-drawer/alio-drawer.component';
import { HeaderComponent } from './header/header.component';
import { LayoutShellComponent } from './layout-shell/layout-shell.component';
import { SidebarMenuComponent } from './sidebar-menu/sidebar-menu.component';

@NgModule({
  declarations: [LayoutShellComponent, SidebarMenuComponent, HeaderComponent, AlioDrawerComponent],
  imports: [CommonModule, RouterModule, SharedModule, AlioModule],
  exports: [LayoutShellComponent],
})
export class LayoutModule {}
